//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MButton from "./MButton";
const { computed, store } = window.MattingEngineModule;
import { getQueryValue } from "@/utils/index";

console.log(window.MattingEngineModule);
export default {
  name: "MattingHeader",
  components: {
    MButton,
  },
  data() {
    return {
      linkTo: "",
    };
  },
  computed: {
    ...computed,
    showHomeButton() {
      const states = ["active"];
      return this.isShowBy(states);
    },
    showBackButton() {
      const states = ["editing"];
      return this.isShowBy(states);
    },
    showEditButton() {
      const states = ["active"];
      return this.isShowBy(states);
    },
    showUploadButton() {
      const states = ["active", "fail"];
      return this.isShowBy(states);
    },
    showDownloadButton() {
      const states = ["active"];
      return this.isShowBy(states);
    },
  },
  created() {
    let link = window.location.pathname.substring(
      0,
      window.location.pathname.lastIndexOf("/")
    );
    if (link) {
      this.linkTo = link;
    }
  },
  methods: {
    isShowBy(states = []) {
      console.log(this.mattingFsmStatus);
      return states.includes(this.mattingFsmStatus);
    },
    matting() {
      this.$root.$emit("matting:create");
    },
    edit() {
      store.mattingFsm.send({
        type: "EDIT",
      });
    },
    back() {
      store.mattingFsm.send("BACK");
    },
    download(type) {
      if (type === "hover") {
        this.$root.$emit("matting:hoverDownload");
      } else {
        this.$root.$emit("matting:clickDownload");
      }
      if (this.showBackButton) {
        this.$root.$emit("matting:download", "advanced"); //背景层的下载
      } else {
        this.$root.$emit("matting:download");
      }
    },
    goHome() {
      // 统一跳转到首页
      let link = "/remove-background";
      let lang = document.documentElement.lang;
      if (lang === "zh" || lang === "en") {
        window.location.href = link;
      } else if (lang === "ja") {
        window.location.href = "https://picwish.com/jp" + link;
      } else if (lang === "vi") {
        window.location.href = "https://picwish.com/vn" + link;
      } else {
        window.location.href = "https://picwish.com/" + lang + link;
      }
    },
  },
};
